import { cva, type VariantProps } from 'class-variance-authority';

export const toastVariants = cva(
  'flex w-full items-start gap-md rounded-md border p-lg shadow-lg data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=closed]:animate-out data-[state=closed]:fade-out-80',
  {
    variants: {
      tone: {
        success: 'border-success/30 bg-card text-foreground',
        error: 'border-destructive/40 bg-card text-foreground',
        warning: 'border-warning/40 bg-card text-foreground',
        info: 'border-border bg-card text-foreground',
        loading: 'border-border bg-card text-foreground',
      },
    },
    defaultVariants: { tone: 'info' },
  },
);

export type ToastVariants = VariantProps<typeof toastVariants>;
